<template>
  <div class="home">
    <h2>Five Chain</h2>
    <JoinForm />

    <button @click="howToPlayClicked">How to Play</button>
  </div>
</template>

<script>
import JoinForm from '@/components/JoinForm.vue'
import { EventBus } from '@/events.js'

export default {
  name: 'HomePage',
  components: { JoinForm },
	methods: {
		howToPlayClicked () { EventBus.$emit('howto'); }
	}
}
</script>
